query getInventorySettings {
  inventorySettings {
    email
    daysToNotifyBeforeRunOut
    pastDaysUsedForCalculation
    xeroConfig {
      isTokenSetValid
      authConsentUrl
      inventoryAssetAccountCode
      inventoryAdjustmentAccountCode
      inventoryCogsAccountCode
      inventoryContactName
      alertEmail
    }
  }
}
